const MemberMenu = [
  {
    name: "Compose SMS",
    link: "/compose",
  },

  {
    name: "Sent Messages",
    link: "/messagehistory",
  },
  {
    name: "Transaction History",
    link: "/transaction-history",
  },
  {
    name: "Phone Book",
    link: "/manage-phonebook",
  },

  {
    name: "Draft SMS",
    link: "/draft-sms",
  },
  {
    name: "Load Voucher",
    link: "/load-voucher",
  },

  {
    name: "Buy SMS Online",
    link: "/buy-sms-online",
  },
];

export default MemberMenu;
